import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GridOptions, GridRow } from '../../grid.types';

@Component({
    selector: 'tt-grid-drill-down',
    templateUrl: './grid-drill-down.component.html',
    styleUrls: ['./grid-drill-down.component.css'],
})
export class GridDrillDownComponent {
    public grid: GridOptions;

    public hasBeenEdited = false;

    constructor(public dialogRef: MatDialogRef<GridDrillDownComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {
        this.grid = Object.assign({}, data.options);
        this.grid.dataTask = Object.assign({}, data.options.dataTask);
        this.grid.dataTask!.loadData!.loadRows = false;
        this.grid.data = Object.assign({}, data.options.data);
        this.grid.data!.rowData = this.data.rows;

        if (this.grid.dataTask?.rememberId) {
            this.grid.dataTask = Object.assign({}, { ...data.options.dataTask, rememberId: data.options.dataTask.rememberId + '.drilldown' });
        }

        this.grid = Object.assign({}, this.grid);

        this.dialogRef.beforeClosed().subscribe({
            next: () => {
                if (this.hasBeenEdited) this.data.options.gridfunc.read();
            },
        });
    }

    public onReady() {
        this.grid.gridfunc?.setDataSource(this.grid.data!.rowData);
    }
}
